import React from 'react';
import {View, ImageSourcePropType, StyleSheet, Image} from 'react-native';
import Circle from 'components/common/animation/Circle';
import colors from 'theme/Colors';
import {corner_radius, spacing} from 'theme/Units';
import {splitStringByWord} from 'utils/splitStringByWords';
import {Text} from 'ui-kits';

type propType = Readonly<{
  image: ImageSourcePropType;
  title: string;
  heading: string;
  description: string;
  highlightText: string;
}>;
export function BackgroundWithGradient({
  image,
  title,
  heading,
  description,
  highlightText,
}: propType) {
  const {before, after, match} = splitStringByWord(heading, highlightText);
  return (
    <View style={styles.container}>
      <Text style={styles.title}>{title}</Text>
      <View style={styles.imageContainer}>
        <Image resizeMode="contain" source={image} style={styles.image} />

        <Text id="launchText" style={styles.launchText}>
          Launching Q4
        </Text>
      </View>
      <Text style={styles.heading}>
        {before}
        <Text style={[styles.heading, styles.headingHighlighted]}>{match}</Text>
        {after}
      </Text>
      <Text style={styles.description}>{description}</Text>
      <Circle
        blurAmount={100}
        color={colors.palette.blueInfo}
        opacity={0.5}
        size={220}
        zIndex={-100}
        x={80}
        y={15}
        width={220}
        height={180}
      />
      <Circle
        blurAmount={100}
        color={colors.palette.brandPink}
        opacity={0.3}
        size={350}
        zIndex={-500}
        x={70}
        y={10}
      />
      <Circle
        blurAmount={100}
        color={colors.palette.brandPink}
        opacity={0.3}
        size={60}
        zIndex={-500}
        x={30}
        y={6}
      />
      <Circle
        blurAmount={60}
        color={colors.palette.brandPink}
        opacity={0.8}
        size={60}
        zIndex={-500}
        x={10}
        y={6}
      />
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    padding: 20,
    borderWidth: 1,
    borderColor: colors.palette.neutralN300,
    backgroundColor: colors.palette.white,
    aspectRatio: '1/1',
    flex: 1,
    maxHeight: 400,
    borderRadius: corner_radius['rounded-lg'] + corner_radius['rounded-sm'],
    overflow: 'hidden',

    shadowColor: 'rgba(0, 0, 0, 0.3)',
    shadowOffset: {width: 5, height: 5},
    shadowOpacity: 0.5,
    shadowRadius: 10,
  },
  textMask: {
    flex: 1,
  },
  imageContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    gap: spacing['1'],
    marginTop: spacing['4'],
  },
  image: {
    width: 200,
    height: 135,
    marginBottom: 4,
    alignSelf: 'center',
  },
  title: {
    fontSize: 22,
    fontWeight: 600,
  },
  headingHighlighted: {
    color: colors.palette.blueInfo,
  },
  launchText: {
    fontSize: 40,
    fontWeight: 400,
    textAlign: 'center',
  },
  heading: {
    fontSize: 19,
    color: colors.palette.black,
    fontWeight: 700,
    flexWrap: 'nowrap',
  },
  description: {
    fontSize: 16,
    fontWeight: 500,
  },
  highlight: {
    fontWeight: 'bold',
    color: 'blue',
  },
});
